// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: '選択',
    titleLinkTooltip: 'ページへ移動',
    collapseCardTooltip: 'カードを閉じる',
    expandCardTooltip: 'カードを開く'
  },
  CardList: {
    loadMore: 'さらに読み込む',
    notFound: 'アイテムが見つかりません。',
    toolbarSelect: '選択',
    viewCards: 'カード',
    viewTiles: 'タイル',
    viewList: 'リスト',
    toolbarView: '表示'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: '終了',
    cancel: '戻る',
    content: 'このウィンドウを終了してよろしいですか？変更したデータは保存されません。'
  },
  Cuttable: {
    showMore: 'さらに表示',
    showLess: '表示数を減らす'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'キャンセル'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'キャンセル'
  },
  Dropdown: {
    close: '閉じる'
  },
  Form: {
    submitButton: '保存',
    applyButton: '適用',
    cancelButton: 'キャンセル'
  },
  FormField: {
    clear: 'クリア',
    remove: '削除',
    addMore: 'もう 1 つ追加',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'パスワードを強化するには：',
    passwordTooShort: 'パスワードを長くします。',
    lettersLowerCase: '小文字を 1 つ以上使用します。',
    lettersUpperCase: '大文字を 1 つ以上使用します。',
    numbers1: '数字を 1 つ以上使用します。',
    numbers3: '数字を 3 つ以上使用します。',
    specialChar1: '特殊文字 (!、@、#、$、%、^、&、*、?、_、~ など) を 1 つ以上使用します。',
    specialChar2: '特殊文字 (!、@、#、$、%、^、&、*、?、_、~ など) を 2 つ以上使用します。',
    comboUpperAndLower: '大文字と小文字の両方を使用します。',
    comboLettersAndNumbers: '数字と文字の両方を使用します。',
    comboLettersNumbersSpecial: '数字、文字、および特殊文字を使用します。',
    yourPasswordIsStrong: '長さを長くすると、さらに強力になります。',
    passwordStrength: 'パスワードの強度は %%strength%% です。',
    strengthVeryStrong: '非常に強い',
    strengthStrong: '強い',
    strengthVeryWeak: '非常に弱い',
    strengthWeak: '弱い',
    strengthMedium: '普通',
    hidePassword: 'パスワードを隠す',
    showPassword: 'パスワードを表示',
    generateButton: '生成',
    copyButtonHint: 'パスワードをコピー',
    copySuccessToast: 'パスワードがコピーされました',
    generateButtonHint: '強いパスワードを生成'
  },
  InPlaceEdit: {
    cancelButtonHint: '変更を破棄',
    editButtonHint: '値を編集',
    okButtonHint: '変更を保存'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'ファイルを選択...'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: '全 %%totalRows%% 件',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: '%%selectedRows%% / %%totalRows%% 件が選択されています',
    all: 'すべて',
    allItemsOnPageSelected: 'ページのすべてのアイテムが選択されています',
    allItemsSelected: 'すべてのアイテムが選択されています',
    selectAllItems: 'すべてのアイテムを選択',
    selectAllItemsOnPage: 'ページのすべてのアイテムを選択',
    deselectAll: '選択解除',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'フィルタと一致するアイテムは見つかりませんでした',
    emptyTitle: 'ここには何もないようです',
    filteredDescription: 'クエリを絞り込むかフィルタ条件の一部を削除して、やり直してください。'
  },
  ListOperation: {
    cancelButton: 'キャンセル'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: '/ %%total%%',
    itemsPerPage: 'ページあたりのアイテム数',
    all: 'すべて',
    total: '%%current%% / %%total%% ページ'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: '閉じる',
    cancelButton: 'キャンセル'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'オプションなし',
    placeholder: '選択...'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%% / %%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'グループを閉じる'
  },
  Toast: {
    closeButton: 'Close'
  }
};